<script context="module" lang="ts">
    import { writable } from "svelte/store"

    type OptInMap = {
        [key: string]: boolean
    }

    // load state from session storage
    const storedOptInMapString = typeof sessionStorage !== "undefined" ? sessionStorage.getItem("optInMap") : null
    const storedOptInMap = storedOptInMapString ? JSON.parse(storedOptInMapString) : null

    const optInMap = writable<OptInMap>(storedOptInMap || {})
    // save state to session storage
    if (typeof sessionStorage !== "undefined") {
        optInMap.subscribe((value) => {
            sessionStorage.setItem("optInMap", JSON.stringify(value))
        })
    }
</script>

<script lang="ts">
    export let key: string

    function acceptCallback() {
        $optInMap[key] = true
    }

    function rejectCallback() {
        $optInMap[key] = false
    }
</script>

{#if $optInMap[key]}
    <slot {rejectCallback} />
{:else}
    <slot name="placeholder" {acceptCallback} />
{/if}
